import { easeOut } from 'just-curves';
import { Sounds } from '../../../@resources/sounds';
import { Client, ClientManager, Communicator } from '../../../concepts/objects';
import { AudioManager } from '../../../platform/AudioManager';
import { Point } from '../../../platform/geom/Point';
import { ActiveObject, resolve } from '../../Container';
import { PreferencesModel } from '../../preferences/PreferencesModel';
import { Camera } from '../Camera';
import { ShittyClientRelay } from '../workspace/participants/ShittyClientRelay';
import { Slap, SlapRelay } from './SlapRelay';

export class SlapMechanics extends ActiveObject {

    @resolve(AudioManager) private audio!: AudioManager;
    @resolve(Camera) private camera!: Camera;
    @resolve(ClientManager) private clients!: ClientManager;
    @resolve(Communicator) private comms!: Communicator;
    @resolve(PreferencesModel) private preferences!: PreferencesModel;
    @resolve(ShittyClientRelay) private clientRelay!: ShittyClientRelay;
    @resolve(SlapRelay) private slapRelay!: SlapRelay;

    private get enabled() {
        return this.preferences.slapping;
    }

    public start = () => this.burden(
        this.slapRelay.on('slap', this.onEmitSlap),
        this.comms.recv('slap', this.onRecvSlap),
    );

    private onEmitSlap = (slap: Slap) => {
        if (!this.enabled) return;
        this.comms.send('slap', slap);
        this.realizeSlap(slap);
    };

    private onRecvSlap = (_sender: Client, slap: Slap) => {
        if (!this.enabled) return;
        this.realizeSlap(slap);
    };

    private realizeSlap = ([target, vector, strength]: Slap) => {
        const { audio, camera } = this;
        const { self } = this.clients;
        audio.play(Sounds.Slap);
        const offset = Point.from(vector).multiply(100 * strength);
        if (self.id === target) {
            camera.animateTo(camera.position.add(offset), null, 100, easeOut);
            self.patch({
                px: (self.profile.px ?? 0) + offset.x,
                py: (self.profile.py ?? 0) + offset.y,
            });
        }
        else {
            this.clientRelay.emit('offset', [target, offset]);
        }
    };
}
